import type { PropsWithChildren } from 'react';
import { SmartLink } from 'Shared/smart_link';

type SupportLinkProps = PropsWithChildren;
export function SupportLink({ children }: SupportLinkProps) {
   return <SmartLink href="/Support">{children}</SmartLink>;
}
